import React from "react";
import { motion } from "framer-motion";
import { CountUp, ArcMotif } from "./Graphics";
import { Overline } from "./primitives";

const EASE = [0.16, 1, 0.3, 1];

const STATS = [
  { to: 3, suffix: "", label: "Pillars in every villa", sub: "Experience · Legacy · Freedom" },
  { to: 84, suffix: "%", label: "Average repeat-guest rate", sub: "Across boutique-hospitality projects" },
  { to: 2.3, suffix: "×", decimals: 1, label: "Asset value uplift", sub: "Versus construction cost" },
  { to: 12, suffix: "", label: "Villas crafted a year", sub: "By invitation, intentionally few" },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="relative overflow-hidden bg-charcoal py-24 text-warm md:py-32">
      <ArcMotif className="pointer-events-none absolute -right-16 -top-10 h-64 w-[28rem] text-champagne/20 md:h-80 md:w-[40rem]" />

      <div className="relative z-10 mx-auto max-w-[1600px] px-6 md:px-12">
        <Overline className="text-copper">Measured In Meaning &amp; Returns</Overline>

        <div className="mt-14 grid grid-cols-2 gap-x-6 gap-y-14 md:mt-20 md:grid-cols-4 md:gap-10">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.9, ease: EASE, delay: i * 0.1 }}
              className="border-t border-warm/15 pt-6"
            >
              <div className="font-serif text-6xl leading-none text-warm md:text-7xl lg:text-[5.5rem]">
                <CountUp to={s.to} suffix={s.suffix} decimals={s.decimals || 0} />
              </div>
              <p className="mt-5 text-sm font-medium uppercase tracking-[0.12em] text-champagne">
                {s.label}
              </p>
              <p className="mt-2 text-sm leading-relaxed text-warm/45">{s.sub}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
